<template>
    <div class="service_banner">
        <div class="container">
            <!-- <Breadcrumb class="bread_block_mod" /> -->
            <CommonBreadcrumb class="bread_block_mod" />
        </div>
        <Customer-serviceIndexPageIndia v-if="$country.is_india" />
        <Customer-serviceIndexPage v-else />
    </div>
</template>

<script setup>
    const { $country } = useNuxtApp();
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>

</style>
